import { customElement, property } from "lit/decorators.js";
import { html, TemplateResult } from "lit";
import "@/components/annotations/annotations_toggles";
import "@/components/annotations/hidden_annotations_dot";
import { userState } from "@/state/Users";
import { annotationState } from "@/state/Annotations";
import { submissionState } from "@/state/Submissions";
import { DodonaElement } from "@/components/meta/dodona_element";
import { I18n } from "@/i18n/i18n";
import { generateUniqueId } from "@/utilities";

/**
 * This component represents the top row with options about annotations, that is displayed above the code listing.
 * It contains the button to add a new global annotation, the global annotations themselves and the toggles to show/hide annotations.
 *
 * @element d-annotation-options
 *
 * @prop {boolean} formShown - Whether the form should be shown (Internal)
 */
@customElement("d-annotation-options")
export class AnnotationOptions extends DodonaElement {
    @property({ state: true })
    formShown = false;

    private readonly cellId = `annotations-cell-${generateUniqueId()}`;

    get canCreateAnnotation(): boolean {
        return userState.hasPermission("annotation.create");
    }

    get addAnnotationTitle(): string {
        return annotationState.isQuestionMode
            ? I18n.t("js.annotations.options.add_global_question")
            : I18n.t("js.annotations.options.add_global_annotation");
    }

    private onOpenForm(): void {
        this.formShown = true;
    }

    private onCloseForm(): void {
        this.formShown = false;
    }

    protected render(): TemplateResult {
        return html`
            <div class="feedback-table-options">
                <d-hidden-annotations-dot .row=${0}></d-hidden-annotations-dot>

                ${
                    this.canCreateAnnotation
                        ? html`
                              <button
                                  type="button"
                                  class="btn btn-outline"
                                  @click=${this.onOpenForm}
                                  aria-controls=${this.cellId}
                                  aria-expanded=${this.formShown ? "true" : "false"}
                              >
                                  ${this.addAnnotationTitle}
                              </button>
                          `
                        : html``
                }
                ${
                    submissionState.canResubmitSubmission
                        ? html`
                              <a
                                  class="btn btn-text resubmit-btn"
                                  href="${submissionState.resubmitPath}"
                                  target="_blank"
                              >
                                  ${I18n.t("js.feedbacks.submission.submit")}
                              </a>
                          `
                        : html``
                }

                <span class="flex-spacer"></span>
                <d-annotations-toggles></d-annotations-toggles>
            </div>

            <div>
                <d-annotations-cell
                    id=${this.cellId}
                    .row=${0}
                    .formShown=${this.formShown}
                    @close-form=${this.onCloseForm}
                ></d-annotations-cell>
            </div>
        `;
    }
}
